import { pick } from 'lodash';
import React, { useEffect, useState } from 'react';
import PricingForm from './components/TripPricing/PricingForm/PricingForm';
import { getPricesByVariation, getVariationPrice } from './utils';
import { useProductTags } from './hooks/useProductTags'
import { useBmsAuth } from './hooks/useBmsAuth'

const BMS_TRIP_FIELD_NAME = 'bms_trip'

const Main = ({ plugin }: any) => {
  const [field, setField] = useState(JSON.parse(plugin.getFieldValue(plugin.fieldPath)));
  const token = useBmsAuth()
  const { tags, fetchTags } = useProductTags()
  const [bmsTrip, setBmsTrip] = useState(JSON.parse(plugin.getFieldValue(BMS_TRIP_FIELD_NAME)));



  useEffect(() => {
    const unsubscribe = plugin.addFieldChangeListener(plugin.fieldPath, (newValue: any) => {
      setField(JSON.parse(newValue));
    });
    const unsubscribeBmsTripField = plugin.addFieldChangeListener(BMS_TRIP_FIELD_NAME, (newValue: any) => {
      setBmsTrip(JSON.parse(newValue));
    });
    return () => {
      unsubscribe();
      unsubscribeBmsTripField();
    };
  }, []);

  useEffect(() => {
    if (token) {
      fetchTags(token)
    }
  }, [token])

  const setWebsitePricing = (newVal: any) => {
    plugin.setFieldValue(plugin.fieldPath, JSON.stringify(newVal));
  };

  const onValueChange = (newPrice: any) => {
    const pricing = field || [];
    const index = pricing.findIndex(
      (price: any) => price.variation_id === newPrice.variation_id,
    );
    if (index > -1) {
      pricing.splice(index, 1, newPrice);
    } else {
      pricing.push(newPrice);
    }
    setWebsitePricing([...pricing]);
  };

  const variation = pick(getPricesByVariation(bmsTrip?.trip_variations), 'twin');
  const filteredVariations = variation.twin?.filter((tripVariation: any) => {
    const actualPrice = getVariationPrice(tripVariation)
    return actualPrice.CAD > 0 && !isNaN(actualPrice.CAD)
  })
  return (
    <div className="container">
      {variation.twin && (
        <div>
          {filteredVariations.length > 0 && filteredVariations.map((tripVariation: any) => (
            <PricingForm
              actualPrice={getVariationPrice(tripVariation)}
              tripVariation={tripVariation}
              key={tripVariation.id}
              ardaPricing={field}
              productTags={tags}
              onValueChange={onValueChange}
            />
          ))}
          {filteredVariations.length === 0 && <div>Trip has no date ranges</div>}
        </div>
      )}
    </div>
  );
};

export default Main;
